import React from 'react'
import { toPath } from '../../../routes'
import { PageHeader } from '../../Common'
import PracticeSelectView from '../../Practices/PracticeSelectView'

export default function Uploads() {
  return (
    <div>
      <PageHeader title="Transmissions Uploads" />
      <PracticeSelectView routeMethod={toPath.practices.uploadNew} />
    </div>
  )
}
